export default {"src":"/_next/static/media/font_filled.b4f79490.svg","height":24,"width":24};